import { useTranslation } from 'react-i18next'

export const getMilestoneTransferTableColumns = () => {
  const { t } = useTranslation()

  return [
    {
      title: t('milestoneTransfer.table.name'),
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: t('milestoneTransfer.table.subcontractorHas'),
      dataIndex: 'exists',
      key: 'exists',
    },
  ]
}
